import {Action} from "../../../action/action";
import type PackageState from "..";
import { Goal } from "@raskrask-dk/raskrask-utils";


const SET_GOAL = "SET_GOAL";
export class SetGoal extends Action<typeof SET_GOAL, Goal> {
  readonly type = SET_GOAL;
  protected state: PackageState;

  constructor(state: PackageState, goal?: Goal) {
    super(state, goal);
    this.state = state;
  }
  isDoable(): boolean {
    throw new Error("Method not implemented.");
  }
  isValid(): boolean {
    throw new Error("Method not implemented.");
  }
}
